import * as angular from 'angular';

export class NextFactory {
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    read(next) {
        return this.$http.get(next);
    }
}

angular
    .module('app')
    .service('NextFactory', NextFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/next.factory.ts